<!-- Header section -->
<div class="header_area ng-star-inserted">
  <a routerLink="/landing" target="_blank">
    <img src="/assets/images/familycentral-logo.svg" alt="Family Central" class="logo_img" width="116">
  </a>
</div>
@if (!isAccessGranted) {
  <div>
    <div>
      <div class="vault-auth-code text-center">
        <p>Enter your 6 digit authentication code for access.</p>
        <p>Your Secure Code will give you one way access to be able to upload information for
          only your clients review.  You will not have access to other parts of the vault just the
        information that you upload.</p>
        <div>
          <form [formGroup]="otpForm" (ngSubmit)="onSubmit()">
            <div class="form-group auth-input">
              <ng-otp-input #ngOtpInput [config]="otpconfig" (onInputChange)="onOtpChange($event)">
              </ng-otp-input>
            </div>
            <div class="fullwidth submit-btn">
              <button type="submit" class="primary_btn" disableDuringAjax>Submit</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
}
@if (isAccessGranted) {
  <div class="page-content">
    <div class="vault-content">
      <div class="text-center">
        <div class="vault-auth-code">
          <img class="mt-3" src="/assets/images/authentication-success-icon.svg" width="78px" height="78px" alt="authentication success icon">
          <h3 class="h3 mt-3">Access Granted!</h3>
        </div>
      </div>
    </div>
  </div>
}